import type { TFunction } from 'i18next';
import { showToast } from 'app/hooks/useToast';

interface NotifyAnalyticsSyncFinishedParams {
  t: TFunction;
  targetLabel?: string;
  hasFailure?: boolean;
  onView?: () => void;
}

export function notifyAnalyticsSyncFinished({
  t,
  targetLabel,
  hasFailure = false,
  onView,
}: NotifyAnalyticsSyncFinishedParams): void {
  const target = targetLabel?.trim();
  const message = hasFailure
    ? target
      ? t('analyticsSyncFinishedToastFailed', { target })
      : t('analyticsSyncFailed')
    : target
    ? t('analyticsSyncFinishedToast', { target })
    : t('analyticsSyncFinishedToastGeneric');

  showToast(message, hasFailure ? 'error' : 'success', {
    ...(onView && {
      cta: {
        label: t('analyticsSyncFinishedToastViewCta'),
        onClick: onView,
      },
    }),
  });
}
